var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.9 24.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maxflet_logo_imagen",
    d: "M1.7 24.3l3.3 0 3.3 -18.8c0,-0.4 0.2,-0.6 0.6,-0.6l2.2 0c0.3,0 0.5,0.1 0.6,0.3l2.6 6.2 4.8 -6.2c0.2,-0.2 0.5,-0.3 0.8,-0.3l13.5 -0.1 0.5 -2.7c0.2,-1.2 -0.6,-2.1 -1.7,-2.1l-26.3 0c-1.1,0 -2.2,0.9 -2.4,2.1l-3.5 20.2c-0.2,1.1 0.6,2 1.7,2zm21.2 -13.4l4 0c0.4,0 0.6,0.2 0.5,0.6l-0.3 1.8c0,0.4 -0.3,0.6 -0.7,0.6l-4 0 0.5 -3zm-14.5 13.4l19.6 0c1.2,0 2.2,-0.9 2.4,-2l2.5 -14.5 -10.7 0 -0.5 3.1 -0.6 3 -0.8 5c-0.1,0.4 -0.3,0.6 -0.7,0.6l-2.3 0c-0.4,0 -0.6,-0.2 -0.5,-0.6l1.5 -8.3 -4.2 5.4c-0.1,0.2 -0.3,0.3 -0.5,0.3 -0.2,0 -0.4,-0.1 -0.5,-0.3l-2.3 -5.4 -2.4 13.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "maxflet_logo_texto",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "txt_et_03",
    d: "M136.4 0l4.9 0c0.5,0 0.7,0.2 0.6,0.7l-0.4 2.1c-0.1,0.5 -0.3,0.7 -0.8,0.7l-5 0 0.7 -3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_m",
    d: "M46.2 13.3c-0.2,0 -0.4,-0.1 -0.5,-0.3l-2.7 -6.3 -1.7 9.6c-0.1,0.5 -0.4,0.7 -0.8,0.7l-2.6 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l2.7 -15.6c0.1,-0.5 0.4,-0.7 0.8,-0.7l2.5 0c0.4,0 0.7,0.1 0.8,0.4l3 7.2 5.6 -7.2c0.2,-0.3 0.5,-0.4 0.8,-0.4l2.6 0c0.5,0 0.8,0.2 0.7,0.7l-2.8 15.6c-0.1,0.5 -0.3,0.7 -0.8,0.7l-2.6 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l1.7 -9.6 -4.9 6.3c-0.1,0.2 -0.3,0.3 -0.6,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_l_01",
    d: "M106.2 0.7l-2.2 12.6 5.9 0c0.5,0 0.7,0.3 0.6,0.7l-0.3 2.3c-0.1,0.5 -0.4,0.7 -0.9,0.7l-9.4 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l2.7 -15.6c0.1,-0.5 0.4,-0.7 0.8,-0.7l2.8 0c0.5,0 0.7,0.2 0.6,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_f_01",
    d: "M91.8 10.5l-1.1 5.8c-0.1,0.5 -0.3,0.7 -0.8,0.7l-2.6 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l2.7 -15.6c0.1,-0.5 0.3,-0.7 0.8,-0.7l9.6 0c0.5,0 0.7,0.2 0.6,0.7l-0.3 2.1c-0.1,0.4 -0.3,0.7 -0.8,0.7l-6.3 0 -0.6 3.6 -0.6 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_x",
    d: "M78.5 11.7l-4 4.7c-0.4,0.4 -0.7,0.6 -1.1,0.6l-2.9 0c-0.3,0 -0.4,-0.1 -0.5,-0.2 0,-0.2 0,-0.4 0.2,-0.6l6.6 -7.8 -3.7 -7.5c-0.1,-0.3 -0.1,-0.5 0,-0.6 0.1,-0.2 0.2,-0.3 0.5,-0.3l2.8 0c0.4,0 0.7,0.2 0.9,0.7l2.3 4.5 3.9 -4.6c0.3,-0.4 0.6,-0.6 1,-0.6l3 0c0.2,0 0.3,0.1 0.4,0.3 0.1,0.1 0,0.3 -0.2,0.6l-6.5 7.6 3.9 7.7c0.1,0.2 0.1,0.4 0,0.6 -0.1,0.1 -0.3,0.2 -0.5,0.2l-2.9 0c-0.3,0 -0.7,-0.2 -0.9,-0.6l-2.3 -4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_et_01",
    d: "M132.3 16.3c-0.1,0.5 -0.4,0.7 -0.8,0.7l-2.8 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l2.3 -12.8 -12.3 0 -0.5 3.2 -0.6 3.3 -0.6 3.6 6.4 0c0.5,0 0.7,0.2 0.7,0.7l-0.4 2c-0.1,0.5 -0.4,0.7 -0.8,0.7l-9.9 0c-0.5,0 -0.7,-0.2 -0.6,-0.7l2.8 -15.6c0.1,-0.5 0.3,-0.7 0.7,-0.7l19.9 0 -2.9 16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_a_01",
    d: "M64.3 0l3.4 0c0.4,0 0.7,0.2 0.8,0.7l2.6 15.5c0,0.3 0,0.4 -0.1,0.6 -0.1,0.2 -0.3,0.2 -0.6,0.2l-2.8 0c-0.4,0 -0.7,-0.2 -0.7,-0.6l-1.5 -12.3 0 0 -5.9 12.3c-0.2,0.4 -0.5,0.6 -0.9,0.6l-2.9 0c-0.3,0 -0.4,0 -0.5,-0.2 -0.1,-0.2 -0.1,-0.4 0.1,-0.6l8.1 -15.6c0.1,-0.2 0.2,-0.4 0.3,-0.5 0.2,-0.1 0.4,-0.1 0.6,-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_et_02",
    d: "M118.7 6.8l5 0c0.5,0 0.7,0.2 0.6,0.7l-0.4 2c-0.1,0.5 -0.3,0.8 -0.8,0.8l-5 0 0.6 -3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_f_02",
    d: "M93.6 6.8l4.7 0c0.5,0 0.7,0.2 0.6,0.7l-0.4 2c-0.1,0.5 -0.3,0.8 -0.8,0.8l-4.7 0 0.6 -3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt_a_02",
    d: "M63.6 10.3l1.4 0 0.4 3.5 -3.4 0 1.6 -3.5z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4f4aa501b38c4fc94163b3967bab38f.svg";
export { ForwardRef as ReactComponent };